import {gql} from '@apollo/client';

export const GetBillPayerLimitations = gql`
    query GetBillPayerLimitations($institutionId: SiteId!) {
        limitationSettings {
            packageLimitationSettings {
                billPayer {
                    creditLimitationWithSiteId(siteId: $institutionId)
                    surchargeLimitationWithSiteId(siteId: $institutionId)
                }
            }
        }
    }
`;

export const UpdateBillingFrequencies = gql`
    mutation UpdateBillingFrequencies(
        $billPayerIds: [BillPayerId!]!
        $invoicingFrequency: AutomaticInvoicingOccurrence!
    ) {
        finance {
            invoices {
                automaticInvoicing {
                    updateBillPayerAutomaticInvoicingSchedules(
                        billPayerIds: $billPayerIds
                        schedule: $invoicingFrequency
                    ) {
                        success
                    }
                }
            }
        }
    }
`;

export const EnableBillPayerAutomaticInvoiceSending = gql`
    mutation EnableBillPayerAutomaticInvoiceSending($billPayerIds: [BillPayerId!]!) {
        finance {
            invoices {
                automaticInvoicing {
                    enableBillPayerAutomaticInvoiceSending(billPayerIds: $billPayerIds) {
                        success
                    }
                }
            }
        }
    }
`;

export const DisableBillPayerAutomaticInvoiceSending = gql`
    mutation DisableBillPayerAutomaticInvoiceSending($billPayerIds: [BillPayerId!]!, $siteSetId: InstitutionSetId!) {
        finance {
            invoices {
                automaticInvoicing {
                    disableOrDeleteAutomaticInvoiceSending(billPayerIds: $billPayerIds, siteSetId: $siteSetId) {
                        success
                    }
                }
            }
        }
    }
`;
